import React, { createContext, useContext, ReactNode } from 'react';
import { usePayerWizard } from '@/hooks/usePayerWizard';

type PayerWizardContextType = ReturnType<typeof usePayerWizard>;

const PayerWizardContext = createContext<PayerWizardContextType | null>(null);

export function PayerWizardProvider({ children }: { children: ReactNode }) {
  const wizard = usePayerWizard();
  
  return (
    <PayerWizardContext.Provider value={wizard}>
      {children}
    </PayerWizardContext.Provider>
  );
}

export function usePayerWizardContext() {
  const context = useContext(PayerWizardContext);
  if (!context) {
    throw new Error('usePayerWizardContext must be used within a PayerWizardProvider');
  }
  return context;
}
